import { render, staticRenderFns } from "./billingNative.vue?vue&type=template&id=60b392f0&scoped=true&"
import script from "./billingNative.vue?vue&type=script&lang=js&"
export * from "./billingNative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b392f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60b392f0')) {
      api.createRecord('60b392f0', component.options)
    } else {
      api.reload('60b392f0', component.options)
    }
    module.hot.accept("./billingNative.vue?vue&type=template&id=60b392f0&scoped=true&", function () {
      api.rerender('60b392f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/billingNative.vue"
export default component.exports